import { render, staticRenderFns } from "./SsoCode.vue?vue&type=template&id=6625f879&scoped=true&"
import script from "./SsoCode.vue?vue&type=script&lang=ts&"
export * from "./SsoCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6625f879",
  null
  
)

export default component.exports